import { updateSegment as apiUpdateSegment } from 'common/api/v1/segmentsLayout';
import { formatSegment } from 'common/components/segment/helpers';

import * as selectors from '../selectors';

import updateSegments from './updateSegments';

export default (segmentId, values) => async (dispatch, getState) => {
    const state = getState();
    const segments = selectors.getSegmentsData(state);
    const parentFieldSegment = selectors.getParentFieldSegmentData(state);
    const existingSegment = segments.find((s) => s.id === segmentId);

    if (!existingSegment) return;

    const {
        beam_spacing,
        building_height,
        category,
        ceil_tilt,
        fill_algorithm,
        front_base_height,
        gclamp_type,
        lfoot_supports_width,
        outer_rail_length,
        plate_support_length,
        preset_configuration,
        rail_spacing,
        rail_support_length,
        seam_distance,
        sheet_gauge,
        sloof_type,
        support_length,
        system,
        system_uid,
        type_application,
    } = values;

    // Rebuild field_segments from the existing segment's polygon.
    // polygon in Redux is [[lat, lng], ...]; API expects {x_coordinate: lng, y_coordinate: lat}.
    // solar_modules in Redux have {enabled, path: [[lat,lng]]}; API expects
    // {is_enable, solar_module_points: JSON.stringify([{x:lng, y:lat}])}.
    const existingPolygon = existingSegment.polygon ?? [];
    const solar_modules = (existingSegment.solar_modules ?? []).map((m) => ({
        cell: m.cell,
        col: m.col,
        group: m.group,
        is_enable: m.enabled,
        row: m.row,
        solar_module_points: JSON.stringify(
            (m.path ?? []).map((point) => ({ x: point[1], y: point[0] })),
        ),
    }));
    const field_segments = [
        {
            name: existingSegment.name ?? '',
            polygon: existingPolygon.map((point) => ({
                x_coordinate: point[1],
                y_coordinate: point[0],
            })),
            solar_modules,
        },
    ];

    const payload = {
        azimuth: existingSegment.azimuth,
        col_spacing: existingSegment.col_spacing,
        commercial_offer: parentFieldSegment?.id,
        custom_inputs: {
            ...existingSegment.custom_inputs,
            beam_spacing,
            building_height,
            category,
            ceil_tilt,
            fill_algorithm,
            front_base_height,
            gclamp_type,
            lfoot_supports_width,
            outer_rail_length,
            plate_support_length,
            preset_configuration,
            rail_spacing,
            rail_support_length,
            seam_distance,
            sheet_gauge,
            sloof_type,
            support_length,
            system_uid,
            type_application,
        },
        field_segments,
        frame_col_spacing: existingSegment.frame_col_spacing,
        frame_cols_number: existingSegment.frame_cols_number,
        frame_row_spacing: existingSegment.frame_row_spacing,
        frame_rows_number: existingSegment.frame_rows_number,
        height: building_height,
        name: existingSegment.name,
        orientation: existingSegment.orientation,
        parent_field_segment:
            existingSegment.parent_field_segment ?? parentFieldSegment?.id,
        polygon: existingPolygon,
        roof_tilt: ceil_tilt,
        row_spacing: existingSegment.row_spacing,
        safe_zone: existingSegment.safe_zone,
        segment_color: existingSegment.segment_color,
        segment_stroke_color: existingSegment.segment_stroke_color,
        solar_module: existingSegment.solar_module,
        solar_modules_number: existingSegment.solar_modules_number,
        system,
        system_uid: system_uid || null,
        tilt: existingSegment.tilt,
        total_area: existingSegment.total_area ?? 0,
        type: existingSegment.type,
        zIndex: existingSegment.zIndex,
    };

    try {
        const response = await apiUpdateSegment(segmentId, payload);
        const segmentData = response?.data?.data ?? response?.data;
        if (segmentData) {
            const updatedSeg = formatSegment(
                segmentData,
                parentFieldSegment?.id,
            );
            const updated = segments.map((s) =>
                s.id === segmentId ? { ...s, ...updatedSeg } : s,
            );
            dispatch(updateSegments(updated));
        }
    } catch (err) {
        console.error('[updateSegmentSettings] failed:', err);
    }
};
